'use client';

import { AngleRightIcon } from '@wolfejs/icons/IconMap';
import { cn } from '@wolfejs/ui/utils/classnames';
import Link from 'next/link';
import React from 'react';

export type NavigationTilesProps = {
  tiles: Tile[];
};

export type Tile = {
  url: string;
  label: string;
  icon: React.ReactNode;
};

export const NavigationTiles = ({ tiles }: NavigationTilesProps) => {
  return (
    <div className={cn('@container')}>
      <div className="@lg:grid-cols-2 @sm:grid-cols-1 @xl:grid-cols-5 grid w-full gap-4 gap-8">
        {tiles?.map(({ url, label, icon }, index) => (
          <Link href={url} key={`tile-${index}`} className="h-full no-underline">
            <div className="bg-primary hover:bg-primary-hover flex h-full flex-col items-center justify-center gap-1 rounded-lg px-8 py-12 text-white ">
              {icon}
              <div className="flex items-center text-base font-normal text-white">
                {label} <AngleRightIcon className="h-3 w-3" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
